import { TbFileExport } from 'react-icons/tb';

import Swal from 'sweetalert2';

import { DataTable } from '../../../../components';
import { api } from '../../../../services/api';
import { useRelatoriosExportados } from '../../../../services/hooks/useRelatoriosExportados';
import { AdminTitle } from '../../components';
import { Container } from './styles';

const tableHead = ['Id', 'Página', 'Data da Exportação', 'Link para Download'];

export const Exportacoes = () => {
  const { data, isLoading, error } = useRelatoriosExportados();

  const handleDownloadFile = async (path: string) => {
    Swal.fire({
      title: 'Carregando...',
      html: 'Aguarde um momento',
      showConfirmButton: false,
    });

    const link = await api.get('transactions/download', {
      params: { fileKey: path },
    });

    Swal.close();

    window.open(link.data.url, '_blank');
  };

  const pages = [
    { label: 'Relatórios', value: 'ordemRepasse' },
    { label: 'Vendas', value: 'transacao' },
    { label: 'Transações Parcelas', value: 'transacaoParcela' },
    { label: 'Extrato', value: 'extrato' },
  ];

  return (
    <Container>
      <AdminTitle title="Exportações" icon={<TbFileExport />} />

      <DataTable title="Detalhado" heads={tableHead} hasPagination={false}>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan={4}>Carregando...</td>
            </tr>
          ) : error ? (
            <tr>
              <td colSpan={4}>Falha ao obter dados</td>
            </tr>
          ) : data?.length === 0 ? (
            <tr>
              <td colSpan={4}>Não foram encontrados dados</td>
            </tr>
          ) : (
            data &&
            data.map((transaction) => (
              <tr key={transaction.id}>
                <td>{transaction.id}</td>
                <td>
                  {
                    pages.find(
                      (page) => page.value === transaction.transactionType
                    )?.label
                  }
                </td>
                <td>
                  {new Date(transaction.created_at).toLocaleDateString('pt-BR')}
                </td>
                <td>
                  {transaction.path ? (
                    <button
                      type="button"
                      onClick={() => handleDownloadFile(transaction.path)}
                    >
                      Link
                    </button>
                  ) : (
                    'Planilha sendo gerada...'
                  )}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </DataTable>
    </Container>
  );
};
